import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";

import Typography from "@material-ui/core/Typography";
import Popover from "@material-ui/core/Popover";

import styled from "styled-components";

const styles = theme => ({
  h3: {
    textAlign: "center",
    paddingLeft: "1rem",
    paddingRight: "1rem"
  },
  typography: {
    margin: theme.spacing.unit * 2
  }
});

const StyledRow = styled(Typography)({
  padding: "5px"
});
const Column = styled.div(props => ({
  display: "flex",
  flexDirection: "column",
  backgroundColor: props.color,
  textAlign: "center"
}));

class InfoPopover extends React.Component {
  state = {
    anchorEl: null
  };

  handleClick = event => {
    this.setState({
      anchorEl: event.currentTarget
    });
  };

  handleClose = () => {
    this.setState({
      anchorEl: null
    });
  };

  render() {
    const { classes, header, text, key } = this.props;
    const { anchorEl } = this.state;
    const open = Boolean(anchorEl);
    return (
      <Column key={`${key}_c`}>
        <this.props.iconImage
          aria-owns={open ? "simple-popper" : undefined}
          aria-haspopup="true"
          variant="contained"
          onClick={this.handleClick}
          style={{ color: "black", width: "20px" }}
        />
        <Popover
          id="simple-popper"
          key={`${key}_p`}
          open={open}
          anchorEl={anchorEl}
          onClose={this.handleClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "center"
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "center"
          }}
        >
          <h3 className={classes.h3}>{header}</h3>
          <StyledRow className={classes.typography}>{text}</StyledRow>
        </Popover>
      </Column>
    );
  }
}

InfoPopover.propTypes = {
  classes: PropTypes.object.isRequired,
  key: PropTypes.string,
  header: PropTypes.string,
  text: PropTypes.string
};

export default withStyles(styles)(InfoPopover);



// WEBPACK FOOTER //
// ./src/components/infoPopOver.js